<!-- tap to top -->
<div class="tap-top top-cls" [class.tap-top--visible]="show" (click)="tapToTop()">
    <div>
      <i class="fa fa-angle-double-up"></i>
    </div>
</div>
<!-- tap to top -->